import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
// import registerServiceWorker from "../src/registerServiceWorker";
import "../src/index.css";
import Campaign from "./container/campaign/Campaign.js";
import User from "./container/user/User.js";
import firebase from "./lib/firebase";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import injectTapEventPlugin from "react-tap-event-plugin";
import Home from "./container/home/Home.js";
import store from "./lib/store";
// import {isRegisterCampaign} from "./lib/user";
// import Home from "bundle-loader?lazy!./container/home/Home.js";
// import LoginDialog from "./container/Auth/LoginDialog";
// import NoticeList from "./container/campaign/component/NoticeList";
// import Nobody from "./container/campaign/component/Nobody";
// import LiveList from "./container/campaign/component/LiveList";
// import firebasPaginater from "firebase-paginator";
// window.firebasPaginater = firebasPaginater;
// import Setting from "./container/campaign/component/Setting";
injectTapEventPlugin();

if (process.env.NODE_ENV !== 'production') {
    window.firebase = firebase;
}

firebase.auth().onAuthStateChanged(function(user) {
    store.dispatch({type:'IS_LOGINED', 'is_logined':user === null ? false : true});
});

class Main extends React.Component {
    render() {
        return (
            <MuiThemeProvider>
                <Router>
                    <div>
                        {/*<Setting campaignId={'egoing2'}></Setting>*/}
                        {/*<Nobody name="land" />*/}
                        {/*<NoticeList campaignId={10000}></NoticeList>*/}
                        {/*<Route path="/" component={Home} />*/}
                        <Route exact path="/" component={Home}/>
                        <Switch>
                            <Route path="/user/:userId" component={User}/>
                            <Route path="/:campaignId/:pageScale?" component={Campaign}/>
                        </Switch>
                        {/*<LiveList campaignId="1"/>*/}
                    </div>
                </Router>
            </MuiThemeProvider>
        );
    }
}

ReactDOM.render(<Main />, document.getElementById('root'));
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js